import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-comment\"><path d=\"M512 156.879c-228.646 0-414 141.654-414 316.394 0 99.1 59.616 187.558 152.934 245.571 21.582 13.417-52.064 148.277-52.064 148.277s186.518-91.257 221.687-85.197c29.418 5.068 60.022 7.744 91.442 7.744 228.646 0 414-141.655 414-316.395S740.646 156.879 512 156.879zM326.388 518h-66.991c-24.341 0-44.073-20.159-44.073-44.5s19.732-44.5 44.073-44.5h66.991c24.341 0 44.073 20.159 44.073 44.5S350.729 518 326.388 518z m218.601 0h-66.991c-24.341 0-44.073-20.159-44.073-44.5s19.732-44.5 44.073-44.5h66.991c24.341 0 44.073 20.159 44.073 44.5S569.33 518 544.989 518z m218.601 0h-66.991c-24.341 0-44.073-20.159-44.073-44.5s19.732-44.5 44.073-44.5h66.991c24.341 0 44.073 20.159 44.073 44.5S787.931 518 763.59 518z\" fill=\"#666666\" p-id=\"11523\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/comment.svg
// module id = SdtW
// module chunks = 45